import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import OrderRow from './OrderRow';
import Loading from '../Loading';
import { Link } from 'react-router-dom';
import moment from 'moment';

const base = 'live-dispatch';

@inject('LiveDispatchStore', 'UserStore', 'StockTransferStoreItems', 'OrdersKitchenStore')
@observer
export default class Orders extends Component {
    state = {
        currentTime: null,
        statusBarColor: '#F4594F',
        packingInOutletWidth: null
    };

    dineInHeadlineRef = React.createRef();
    dineInTableRef = React.createRef();

    componentDidMount = () => {
        this.currentTime();
        this.updatePackingInOutletWidth();
    };

    componentWillUnmount = () => {
        if (this.timeOut) {
            clearTimeout(this.timeOut);
        }
    };

    currentTime = () => {
        const currentTime = moment().format('LTS');
        if (moment().second() % 2 === 0){
            this.setState({statusBarColor: 'black'})
        } else {
            this.setState({statusBarColor: '#F4594F'})
        }
        this.setState({ currentTime });
        this.timeOut = setTimeout(this.currentTime, 1000);
    };

    handleClickOpenModal = () => {
        const { LiveDispatchStore } = this.props;
        LiveDispatchStore.recentlyClosedAggregatorStores = LiveDispatchStore.closedAggregatorStores;
    }

    handleClickOpenCardTerminalNotConnectedModal = () => {
        const { LiveDispatchStore } = this.props;
        LiveDispatchStore.cardTerminalNotConnected = true;
        LiveDispatchStore.showCardTerminalNotConnectedModal = true;
    }

    handleClickOpenTruckModal = () => {
        const { LiveDispatchStore } = this.props;
        LiveDispatchStore.recentTruckAlerts = LiveDispatchStore.truckAlerts.filter(alert => !alert.acknowledged);
    }

    componentDidUpdate(prevProps) {
        const { lastScannedItem, LiveDispatchStore, inOutletOrders } = this.props;
        const { updateItemStatus} = LiveDispatchStore;
        if (prevProps.lastScannedItem !== lastScannedItem) {
            updateItemStatus( lastScannedItem, inOutletOrders );
        }
        this.updatePackingInOutletWidth();
    }

    updatePackingInOutletWidth = () => {
        const { isPackingV2, inOutletOrders } = this.props;
        const { packingInOutletWidth } = this.state;

        if (!isPackingV2 || !inOutletOrders || !this.dineInTableRef.current) {
            if (packingInOutletWidth !== null) {
                this.setState({ packingInOutletWidth: null });
            }
            return;
        }

        const table = this.dineInTableRef.current;
        const tableRect = table.getBoundingClientRect();
        const tableStyles = window.getComputedStyle(table);
        const paddingRight = parseFloat(tableStyles.paddingRight) || 0;
        const orderCards = Array.from(table.children);
        const tableContentWidth = orderCards.reduce((maxWidth, card) => {
            const cardRect = card.getBoundingClientRect();
            return Math.max(maxWidth, cardRect.right - tableRect.left + paddingRight);
        }, 0);
        const headlineRect = this.dineInHeadlineRef.current
            ? this.dineInHeadlineRef.current.getBoundingClientRect()
            : null;
        const headlineWidth = headlineRect
            ? Array.from(this.dineInHeadlineRef.current.querySelectorAll('p')).reduce(
                (maxWidth, headlineItem) => {
                    const headlineItemRect = headlineItem.getBoundingClientRect();
                    return Math.max(maxWidth, headlineItemRect.right - headlineRect.left);
                },
                0
            )
            : 0;
        const nextWidth = Math.ceil(Math.max(tableContentWidth, headlineWidth));

        if (nextWidth > 0 && Math.abs(nextWidth - (packingInOutletWidth || 0)) > 1) {
            this.setState({ packingInOutletWidth: nextWidth });
        }
    };

    isOrderFullyScanned = (order) => {
        if (!order || !order.items || order.items.length === 0) {
            return false;
        }

        return order.items.every((item) => item.status === 'ON_ROUTE');
    };

    hasAssignedBagNumber = (order) => {
        if (!order || order.bag_number == null) {
            return false;
        }

        const normalizedBagNumber = String(order.bag_number).trim();
        return normalizedBagNumber !== '' && normalizedBagNumber !== '-';
    };

    shouldHideScheduledSelfPickupInPackingV2 = (order) => {
        const isSelfPickupOrder =
            order &&
            (order.order_mode === 'PANDU_MASUK' ||
                order.order_mode === 'PANDU_LALU' ||
                order.customer_self_pickup_at_outlet === true);

        return isSelfPickupOrder && !this.hasAssignedBagNumber(order);
    };

    isOrderRowVisible = (order) => {
        const { LiveDispatchStore } = this.props;

        if (!order || !order.items || order.items.length === 0) {
            return false;
        }

        if (LiveDispatchStore.shouldShowDineInOrder(order)) {
            return true;
        }

        if (this.isOrderFullyScanned(order)) {
            return false;
        }

        return !(
            this.props.isPackingV2 &&
            this.shouldHideScheduledSelfPickupInPackingV2(order)
        );
    };

    render() {
        const {
            LiveDispatchStore,
            UserStore,
            StockTransferStoreItems,
            inOutletOrders,
            routeSectionVisible,
            lastScannedItem,
            isPackingV2,
            renderOrderAddon,
        } = this.props;
        const { bags, dineInOrders, inCartOrders, instaServiceProductions, loading, closedAggregatorStores, recentlyClosedAggregatorStores, truckAlerts, recentTruckAlerts, cardTerminalNotConnected } = LiveDispatchStore;
        const unacknowledgedTruckAlerts = truckAlerts.filter(alert => !alert.acknowledged);
        const { isCurrentPageFullScreen } = UserStore;
        const { receipts } = StockTransferStoreItems;
        const { packingInOutletWidth } = this.state;
        const packingInOutletWidthStyle =
            packingInOutletWidth != null ? `${packingInOutletWidth}px` : 'max-content';

        let orders = [];
        if (inOutletOrders) {
            dineInOrders.filter((order) => (order.production_started_at && (order.sale_platform == "Pick Up" || order.sale_platform == "Dine In"))).map((dineInOrder) => (
                orders.push(dineInOrder)
            ));

            bags.filter((order) => (order.production_started_at && (order.order_mode == "PICK_UP" || order.order_mode == "PANDU_MASUK" || order.order_mode == "PANDU_LALU") )).map((bag) => (
                orders.push(bag)
            ));

            orders.sort((a, b) => a.production_started_at - b.production_started_at);
            
            const incomingOrders = inCartOrders ? inCartOrders : [];
            incomingOrders.filter((order) => (order.items && order.items.length > 0))
            .map((inCartOrder) => (
                orders.push(inCartOrder)
            ));
        }
        
        if (!inOutletOrders) {
            bags.filter((order) => order.production_started_at && order.order_mode != "PICK_UP" && order.order_mode != "PANDU_MASUK" && order.order_mode != "PANDU_LALU").map((bag) => (
                orders.push(bag)
            ));

            dineInOrders.filter((order) => (order.production_started_at && (order.sale_platform != "Pick Up" && order.sale_platform != "Dine In"))).map((dineInOrder) => (
                orders.push(dineInOrder)
            ));
            
            orders.sort((a, b) => a.production_started_at - b.production_started_at);
        }

        let height;

        if (!isPackingV2) {
            if (isCurrentPageFullScreen) {
                if (instaServiceProductions != null && instaServiceProductions.length > 0) {
                    height = routeSectionVisible ? '38.2vh' : '60vh';
                } else {
                    height = routeSectionVisible ? '64vh' : '87vh';
                }
            } else {
                if (instaServiceProductions != null && instaServiceProductions.length > 0) {
                    height = routeSectionVisible ? '31.25vh' : '53.75vh';
                } else {
                    height = routeSectionVisible ? '50vh' : '77vh';
                }
            }
        }

        if (loading) {
            return <Loading />;
        }

        return (
            <div
                className={`${base}__dine-in-container`}
                style={
                    isPackingV2
                        ? {
                            display: 'flex',
                            flexDirection: 'column',
                            height: '100%',
                            minHeight: 0,
                            width: inOutletOrders ? packingInOutletWidthStyle : '100%',
                            minWidth: inOutletOrders ? packingInOutletWidthStyle : 0,
                        }
                        : undefined
                }
            >
                <div className={`${base}__dine-in-headline`} ref={this.dineInHeadlineRef}>
                    <h1 className={`display--inline-block`} style={{width: '100%'}}>
                        {inOutletOrders && (
                            <div className={`${isPackingV2 ? 'packing-v2__orders-title-row' : ''} display--flex`}>
                                <p className={`${base}__heading`}>Dine-in + Takeaway</p>

                            <p  
                            className={isPackingV2 ? 'packing-v2__orders-priority-label' : ''}
                            style={{
                                backgroundColor: '#F4594F',
                                borderRadius: '10px',
                                color: 'white',
                                padding: '5px',
                                fontSize: '20px',
                                height: 'fit-content',
                                margin: '15px 0px 0px 0px'
                                }}
                        >
                                PRIORITI
                            </p>
                            </div>
                        )}
                        {!inOutletOrders && (
                            <div className={`${isPackingV2 ? 'packing-v2__orders-title-row packing-v2__orders-title-row--delivery' : ''} display--flex`} style={{ justifyContent: 'space-between', flexWrap: 'wrap' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <p className={`${base}__heading`} style={{ marginRight: '10px' }}>Delivery</p>
                                    { receipts.length > 0
                                        && 
                                        <Link to="/inventory/receive-stock">
                                            <button className="fs--medium-medium-large m0 mlm" 
                                                style={{
                                                    backgroundColor: this.state.statusBarColor,
                                                    borderRadius: '20px',
                                                    color: 'white',
                                                    fontSize: '17.5px',
                                                    padding: '5px',
                                                    margin: '8px 25px 8px 0'
                                                    }}
                                            >
                                                You have a pending receipt!
                                            </button>
                                        </Link>
                                    }
                                    {recentlyClosedAggregatorStores.length === 0 && closedAggregatorStores.length > 0
                                        && 
                                        <button className="fs--medium-medium-large m0 mlm" 
                                            style={{
                                                backgroundColor: this.state.statusBarColor,
                                                borderRadius: '20px',
                                                color: 'white',
                                                fontSize: '17.5px',
                                                padding: '5px',
                                                margin: '8px 25px 8px 0'
                                                }}
                                                onClick={this.handleClickOpenModal}
                                        >
                                                ALERT {closedAggregatorStores.map(p => (<span key={p}>{p + " "}</span>))} is closed! Re-open now!
                                    </button>
                                    }
                                    {recentTruckAlerts.length === 0 && unacknowledgedTruckAlerts.length > 0
                                        && 
                                        <button className="fs--medium-medium-large m0 mlm" 
                                            style={{
                                                backgroundColor: this.state.statusBarColor,
                                                borderRadius: '20px',
                                                color: 'white',
                                                fontSize: '17.5px',
                                                padding: '5px',
                                                margin: '8px 25px 8px 0'
                                                }}
                                                onClick={this.handleClickOpenTruckModal}
                                        >
                                                ALERT {unacknowledgedTruckAlerts.map(alert => (<span key={alert.id}>{alert.status + " "}</span>))}
                                    </button>
                                    }
                                    {cardTerminalNotConnected && 
                                        <button className="fs--medium-medium-large m0 mlm" 
                                            style={{
                                                backgroundColor: this.state.statusBarColor,
                                                borderRadius: '20px',
                                                color: 'white',
                                                fontSize: '17.5px',
                                                padding: '5px',
                                                margin: '8px 25px 8px 0'
                                                }}
                                                onClick={this.handleClickOpenCardTerminalNotConnectedModal}
                                        >
                                                Restart your iPad! Card terminal not connected!
                                    </button>
                                    }
                                </div>
                            </div>                            
                        )}
                    </h1>
                </div>
                <div
                    ref={this.dineInTableRef}
                    className={`${base}__dine-in-table display--flex`}
                    style={
                        isPackingV2
                            ? {
                                flex: '1 1 auto',
                                minHeight: 0,
                                overflowY: 'auto',
                                overflowX: inOutletOrders ? 'visible' : 'hidden',
                                width: inOutletOrders ? packingInOutletWidthStyle : 'auto',
                            }
                            : { height }
                    }
                >
                    {orders
                        .filter((order) => this.isOrderRowVisible(order))
                        .map((order) => (
                            <div className={`${base}__packing-order-with-addon`} key={order.order_number}>
                                <OrderRow
                                    order={order}
                                    lastScannedItem={lastScannedItem}
                                    inOutletOrders={inOutletOrders}
                                    isPackingV2={isPackingV2}
                                />
                                {renderOrderAddon && order.order_number ? renderOrderAddon(order) : null}
                            </div>
                        ))}                    
                </div>
            </div>
        );
    }
}
